class Product {
  constructor() {
    (this.acc = []),
      (this.container = document.querySelector(".m-main-product")),
      MinimogTheme.CompareProduct &&
        MinimogTheme.CompareProduct.setCompareButtonsState(),
      MinimogTheme.Wishlist && MinimogTheme.Wishlist.setWishlistButtonsState(),
      this.addRecentViewedProduct(),
      addEventDelegate({
        context: this.container,
        selector:
          (window.__minimog_review_selector || "") +
          ".m-product-collapsible .jdgm-widget-actions-wrapper, .m-product-collapsible .spr-summary-actions-newreview",
        handler: (e) => {
          const t = e.target.closest(".m-product-collapsible").dataset.index;
          setTimeout(() => {
            this.acc[Number(t)].setContentHeight();
          }, 300);
        },
        capture: !0,
      });
  }
  addRecentViewedProduct() {
    const e = getCookie("m-recent-viewed-products");
    let t = e ? JSON.parse(e) : [];
    -1 === t.indexOf(MinimogSettings.productHandle) &&
      (t.unshift(MinimogSettings.productHandle),
      (t = t.slice(0, 20)),
      setCookie("m-recent-viewed-products", JSON.stringify(t)));
  }
}

window.addEventListener("DOMContentLoaded", () => {
  let openSeeMore = false;
  const productFeatures = document.querySelectorAll(
    ".main-product__block-product-value"
  );
  let productFeatureFirst = null;

  if (productFeatures) {
    productFeatureFirst = productFeatures[0];
  }

  const productFeatureContainer = document.createElement("div");
  productFeatureContainer.classList.add("product-feature-container");

  if (productFeatureFirst) {
    productFeatureFirst.before(productFeatureContainer);
  }
  productFeatureContainer.previousElementSibling.classList.add("product-promo");

  productFeatures.forEach((feature) => {
    feature.classList.add("hidden-feature");
  });
  productFeatures.forEach((feature, idx) => {
    if (idx < 4) {
      feature.classList.toggle("hidden-feature");
    }
    productFeatureContainer.appendChild(feature);
  });

  if (productFeatures.length > 4) {
    const div = document.createElement("div");
    div.classList.add("product-value__see-more");
    const p = document.createElement("p");
    p.classList.add("see-more");
    p.textContent = "See More";
    div.appendChild(p);
    div.addEventListener("click", (e) => {
      openSeeMore = !openSeeMore;
      productFeatures.forEach((feature, idx) => {
        if (idx >= 4) {
          feature.classList.toggle("hidden-feature");
        }
      });
      if (openSeeMore) {
        p.textContent = "See Less";
      } else {
        p.textContent = "See More";
      }
    });
    productFeatureContainer.appendChild(div);
  }
});
